import { useRecoilState } from 'recoil';
import { CheckBoxField } from 'components/core';
import { builderAnswersState } from 'states';
import { CustomSource } from 'helpers/kpiBuilder/types';
import { BuilderSection } from './BuilderSection';
import { TextBox } from './TextBox';

// Data that is not in the catalogue: name its index and date field, and everything else can be typed.
export const CustomSourceFields = () => {
  const [a, setA] = useRecoilState(builderAnswersState);
  const s = a.custom.source;
  const set = (next: Partial<CustomSource>) => setA({ ...a, custom: { ...a.custom, source: { ...s, ...next } } });

  return (
    <BuilderSection title="Tell us about this data" hint="Type the index name without dev- or prod-, so the KPI works in every environment. The date field is what the dashboard's date filter uses.">
      <div className="row g-2">
        <div className="col-md-6"><TextBox value={s.index} placeholder="Index name, e.g. drishti-enriched-user-session-activity" onChange={(index) => set({ index })} /></div>
        <div className="col-md-6"><TextBox value={s.date} placeholder="Date field, e.g. enrolledDateTimestamp" onChange={(date) => set({ date })} /></div>
        <div className="col-md-6"><TextBox value={s.label} placeholder="Name for this data, e.g. Session activity" onChange={(label) => set({ label })} /></div>
        <div className="col-md-6"><TextBox value={s.comp} placeholder="Optional: competency field, for the competency filter" onChange={(comp) => set({ comp })} /></div>
      </div>
      <CheckBoxField label="This data has district, block and facility fields" subLabel="Turn off if the dashboard's location filters should not apply to it." isChecked={s.hasLocation} clickHandler={() => set({ hasLocation: !s.hasLocation })} />
    </BuilderSection>
  );
};
